import { binaryInsert } from 'binary-insert';

export default {
  setPersons(state, { persons }) {
    state.persons = [];
    for (let person of persons) {
      this.commit('addPerson', { person });
    }
  },
  addPerson(state, { person }) {
    // Insert the person alphabetically sorted
    binaryInsert(state.persons, person, (personA, personB) => {
      const nameA = personA.name.toLowerCase(),
        nameB = personB.name.toLowerCase();
      const lastNameA = nameA
          .trim()
          .split(/ +/)
          .last(),
        lastNameB = nameB
          .trim()
          .split(/ +/)
          .last();
      return lastNameA > lastNameB
        ? 1
        : lastNameA < lastNameB
        ? -1
        : nameA > nameB
        ? 1
        : nameA < nameB
        ? -1
        : (personA.id > personB.id) * 2 - 1;
    });
  },
  updatePerson(state, { person }) {
    /*state.persons = state.persons.map((p) =>
      p.id === person.id ? person : p
    );*/
    // --> Re-binary-insert the person, in case its name changes
    this.commit('deletePerson', { id: person.id });
    this.commit('addPerson', { person });
  },
  deletePerson(state, { id }) {
    state.persons = state.persons.filter((p) => p.id !== id);
  },
};
